import React, { useEffect } from 'react';
import moment from 'moment';
import { useLocalStorageState } from 'ahooks';

import EventIcon from './event-icon';

import styles from './index.less';

const SummaryConv = props => {

  const { data } = props;
  const [, setGptSummaryMsgIds] = useLocalStorageState('gptSummaryMsgIds', []);

  const { action, content: contentBody, time } = data;

  const { content = '', event_id = '' } = contentBody;

  useEffect(() => {
    setGptSummaryMsgIds(prev => {
      return prev?.filter(id => id != event_id);
    });
  }, [event_id]);

  const date = moment
    .utc(time)
    .local()
    .format('MM/DD HH:mm:ss');

  return (
    <div className={styles['event-box']}>
      <ul className={styles.header}>
        <li>
          <EventIcon action={action} />
        </li>
        <li className={styles.date}>{date}</li>
        <li>{'系统自动生成对话总结'}</li>
      </ul>
      <div
        className={styles.summaryBody}
        dangerouslySetInnerHTML={{
          __html: content
        }}
      />
    </div>
  );
};

export default SummaryConv;
